export default {
  name: 'Footer',
  props: {
    val: Object
  },
}